export default [
	'em-tlj-1',
	'em-tlj-3',
	'em-tlj-4',
	'em-tlj-5',
	'em-tlj-6',
	'em-tlj-7',
	'em-tlj-8',
	'em-tlj-9',
	'em-tlj-10',
	'em-tlj-11',
	'em-tlj-12',
	'em-tlj-13',
	'em-tlj-14',
	'em-tlj-15',
	'em-tlj-16',
	'em-tlj-17',
	'em-tlj-18',
	'em-tlj-19',
	'em-tlj-20',
	'em-tlj-21',
	'em-tlj-22',
	'em-tlj-23',
	'em-tlj-24',
	'em-tlj-25',
	'em-tlj-26',
	'em-tlj-27',
	'em-tlj-28',
	'em-tlj-29',
	'em-tlj-30',
	'em-tlj-31',
	'em-tlj-32',
	'em-tlj-33',
	'em-tlj-34',
	'em-tlj-35',
	'em-tlj-36',
	'em-tlj-37',
	'em-tlj-38',
	'em-tlj-39',
	'em-tlj-40',
	'em-tlj-41',
	'em-tlj-42',
	'em-tlj-43',
	'em-tlj-44',
	'em-tlj-45',
	'em-tlj-46',
	'em-tlj-47',
	'em-tlj-48',
	'em-tlj-49',
	'em-tlj-50',
	'em-tlj-51',
	'em-tlj-52',
	'em-tlj-53',
	'em-tlj-54',
	'em-tlj-55',
	'em-tlj-56',
	'em-tlj-57',
	'em-tlj-58',
	'em-tlj-59',
	'em-tlj-60',
	'em-tlj-61',
	'em-tlj-62',
	'em-tlj-63',
	'em-tlj-64',
	'em-tlj-65',
	'em-tlj-66',
	'em-tlj-67',
	'em-tlj-68',
	'em-tlj-69',
	'em-tlj-70',
	'em-tlj-71',
	'em-tlj-72',
	'em-tlj-73',
	'em-tlj-74',
	'em-tlj-75',
	'em-tlj-76',
	'em-tlj-77',
	'em-tlj-78',
	'em-tlj-79',
	'em-tlj-80',
	'em-tlj-81',
	'em-tlj-82',
	'em-tlj-83',
	'em-tlj-84',
	'em-tlj-85',
	'em-tlj-86',
	'em-tlj-87',
	'em-tlj-88',
	'em-tlj-89',
	'em-tlj-90',
	'em-tlj-91',
	'em-tlj-92',
	'em-tlj-93',
	'em-tlj-94',
	'em-tlj-95',
	'em-tlj-96',
	"em-smile",
	"em-laughing",
	"em-blush",
	"em-smiley",
	"em-relaxed",
	"em-smirk",
	"em-heart_eyes",
	"em-kissing_heart",
	"em-kissing_closed_eyes",
	"em-flushed",
	"em-relieved",
	"em-satisfied",
	"em-grin",
	"em-wink",
	"em-stuck_out_tongue_winking_eye",
	"em-stuck_out_tongue_closed_eyes",
	"em-grinning",
	"em-kissing",
	"em-kissing_smiling_eyes",
	"em-stuck_out_tongue",
	"em-sleeping",
	"em-worried",
	"em-frowning",
	"em-anguished",
	"em-open_mouth",
	"em-grimacing",
	"em-confused",
	"em-hushed",
	"em-expressionless",
	"em-unamused",
	"em-sweat_smile",
	"em-sweat",
	"em-disappointed_relieved",
	"em-weary",
	"em-pensive",
	"em-disappointed",
	"em-confounded",
	"em-fearful",
	"em-cold_sweat",
	"em-persevere",
	"em-cry",
	"em-sob",
	"em-joy",
	"em-astonished",
	"em-scream",
	"em-tired_face",
	"em-angry",
	"em-rage",
	"em-triumph",
	"em-sleepy",
	"em-yum",
	"em-mask",
	"em-sunglasses",
	"em-dizzy_face",
	"em-imp",
	"em-smiling_imp",
	"em-neutral_face",
	"em-no_mouth",
	"em-innocent",
	"em-alien"
];